import React from "react"
import { Async, GoBack, Loader } from "uikit"

const DownloadCase = ({ getScenarioCase, scenarioId }) => (
  <Async
    resolve={() => getScenarioCase(scenarioId)}
    pending={<Loader text="Please wait while dumping data..." />}
    fulfilled={data => {
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: "application/json"
      })
      const url = window.URL.createObjectURL(blob)
      const tempAnchor = document.createElement("a")
      tempAnchor.href = url
      tempAnchor.setAttribute(
        "download",
        `evauation_case-${new Date().toISOString()}.json`
      )
      tempAnchor.click()
      return <GoBack />
    }}
  />
)

export default DownloadCase
